import type { TagDto, TagTarget } from '@pb/shared';
import { asList, del, get, patch, post } from './client';

export const listTags = async (projectId: number) =>
  asList(await get<TagDto[] | { items: TagDto[] }>(`/projects/${projectId}/tags`));
export const createTag = (projectId: number, name: string) => post<TagDto>(`/projects/${projectId}/tags`, { name });
export const updateTag = (tagId: number, name: string) => patch<TagDto>(`/tags/${tagId}`, { name });
export const deleteTag = (tagId: number, confirm: string) => del<unknown>(`/tags/${tagId}`, { confirm });
export const setTags = (target: TagTarget, ids: number[], tagIds: number[]) =>
  post<unknown>('/tags/assign', { target, ids, tag_ids: tagIds });
